export default {
  GET_PENDING_ORDERS: `query PendingOrderDeliveries {
    getPendingOrderDeliveries { delivery order orderCreatedAt estimatedDeliveryAt locationRecipient conveyor createdAt }
  }`,

  GET_ALL: `#graphql
  query getDeliveries($search: String, $searchBy: String, $search1: String, $searchBy1: String, $limit: Int, $page: Int, $sort: String, $order: String, $init: Date, $final: Date) {
    getDeliveries(search: $search, searchBy: $searchBy, search1: $search1, searchBy1: $searchBy1, limit: $limit, page: $page, sort: $sort, order: $order, init:  $init, final: $final)
    { 
      docs {
        delivery,
        order,
        change,
        status,
        observations {
          observation,
          createdAt,
          createdBy
        }
        charge,
        replacementCharge,
        addressRecipient,
        locationRecipient,
        departmentRecipient,
        nameRecipient,
        addressRecipient,
        phonesRecipient,
        conveyor,
        cost,
        estimatedCost,
        tracking,
        dniDeliveryMan,
        nameDeliveryMan,
        createdBy,
        createdAt,
        deliveredBy,
        deliveredAt,
        inProgressAt,
        inProgressBy,
        declinedAt,
        declinedBy,
        deliveredAt,
        deliveredBy,
        leftBuildingReception,
        paidAt,
        paidBy,
        collectedAt,
        collectedBy,
        type,
        brand,
        receipts
      },
      totalDocs,
      limit,
      hasPrevPage,
      hasNextPage,
      page,
      totalPages,
      prevPage,
      nextPage,
      pagingCounter
    }            
  }`,

  GET_HISTORY: `#graphql
  query getDeliveriesHistory($search: String, $searchBy: String, $search1: String, $searchBy1: String, $limit: Int, $page: Int, $sort: String, $order: String, $init: Date, $final: Date) {
    getDeliveriesHistory(search: $search, searchBy: $searchBy, search1: $search1, searchBy1: $searchBy1, limit: $limit, page: $page, sort: $sort, order: $order, init:  $init, final: $final)
    { 
      docs {
        _id,
        version,
        delivery,
        order,
        status,
        address,
        observations {
          observation,
          createdAt,
          createdBy
        }
        charge,
        locationRecipient,
        departmentRecipient,
        nameRecipient,
        addressRecipient,
        phonesRecipient,
        conveyor,
        tracking,
        cost,
        estimatedCost,
        dniDeliveryMan,
        nameDeliveryMan,
        transaction,
        updatedAt,
        createdBy,
        createdAt,
        deliveredBy,
        deliveredAt,
        inProgressAt,
        inProgressBy,
        declinedAt,
        declinedBy,
        deliveredAt,
        deliveredBy,
        leftBuildingReception,
        paidAt,
        paidBy,
        collectedAt,
        collectedBy,
        type,
        receipts
      },
      totalDocs,
      limit,
      hasPrevPage,
      hasNextPage,
      page,
      totalPages,
      prevPage,
      nextPage,
      pagingCounter
    }            
  }`,

  UPDATE: `#graphql
  mutation UpdateDelivery($delivery: String!, $deliveryUpdate: DeliveryUpdateInput!, $sendNotifications: Boolean) {
    updateDelivery(delivery:$delivery, deliveryUpdate: $deliveryUpdate, sendNotifications: $sendNotifications)
    {
      delivery  
    }            
  }`,

  DELETE: `#graphql
  mutation DeleteDelivery($delivery: String!) {
    deleteDelivery(delivery:$delivery)
    {
      delivery
    }            
  }`,

  IN_PROGRESS: `#graphql
  mutation DeliveryInProgress($delivery: String!, $sendNotifications: Boolean!) {
    deliveryInProgress(delivery: $delivery, sendNotifications: $sendNotifications)          
  }`,

  DECLINE: `#graphql
  mutation DeclineDelivery($delivery: String!) {
    declineDelivery(delivery: $delivery)          
  }`,

  CANCEL_TRACKING: `#graphql
  mutation CancelDeliveryTracking($delivery: String!) {
    cancelDeliveryTracking(delivery: $delivery)
  }`,

  CANCEL_DELIVERY_IN_PROCESS: `#graphql
  mutation CancelDeliveryInProcess($delivery: String!) {
    cancelDeliveryInProcess(delivery: $delivery)          
  }`,

  DELIVERED: `#graphql
  mutation DeliveryDelivered($delivery: String!, $leftBuildingReception: Boolean!, $sendNotifications: Boolean!, $deliveredAt: Date) {
    deliveryDelivered(delivery: $delivery, leftBuildingReception: $leftBuildingReception, sendNotifications: $sendNotifications, deliveredAt: $deliveredAt)          
  }`,

  CANCEL_DELIVERED: `#graphql
  mutation CancelDelivered($delivery: String!) {
    cancelDelivered(delivery: $delivery)          
  }`,

  COLLECT_CHARGE: `#graphql
  mutation CollectCharge($delivery: String!) {
    collectCharge(delivery: $delivery)          
  }`,

  PAY_DELIVERY: `#graphql
  mutation PayDelivery($delivery: String!) {
    payDelivery(delivery: $delivery)          
  }`,

  CANCEL_COLLECT_CHARGE: `#graphql
  mutation CancelCollectCharge($delivery: String!) {
    cancelCollectCharge(delivery: $delivery)          
  }`,

  CANCEL_PAY_DELIVERY: `#graphql
  mutation CancelPayDelivery($delivery: String!) {
    cancelPayDelivery(delivery: $delivery)          
  }`,

  ADD_OBSERVATION: `#graphql
  mutation addObservationDelivery($delivery: String!, $observation: String!) {
    addObservationDelivery(delivery: $delivery, observation: $observation)        
  }`,

  INTEGRATION: `#graphql
  mutation integrationDelivery($delivery: DeliveryIntegrationInput!) {
    integrationDelivery(delivery: $delivery)        
  }`,

  UPDATE_DELIVERY_MAN: `#graphql
  mutation updateDeliveryMan($order: String, $change: String, $dniDeliveryMan: String!) {
    updateDeliveryMan(order: $order, change: $change, dniDeliveryMan: $dniDeliveryMan)        
  }`,

  DELETE_IMAGE: `#graphql
  mutation deleteImageDelivery($delivery: String!, $image: String!) {
    deleteImageDelivery(delivery: $delivery, image: $image)        
  }`
}



// WEBPACK FOOTER //
// ./src/graphql/delivery.js